import { Component} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AssetInventoryService } from '../../services/asset-inventory.service';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { AssetInventory } from '../../models/entities/asset-inventory';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { AssetPipe } from '../../pipes/asset-pipe';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';


@Component({
    selector: 'asset-inventory-widget',
    templateUrl: './asset-inventory-widget.component.html',
    styleUrls: ['./asset-inventory-widget.component.scss']
})

export class AssetInventoryWidgetComponent extends BaseWidget {

  assetInventory       : AssetInventory = new AssetInventory();
  assetPipe            : AssetPipe = new AssetPipe();


  assetColumns = [  
  //  { prop: 'branch.name"',       name: 'Agence' },
 
  { prop: 'barCode',                     name: 'Code à barres',           pipe : this.assetPipe},
  { prop: 'serialNumber',                name: 'N° serie'                                       },
  { prop: 'assetStatusCode',             name: 'Statut',                  pipe : this.assetPipe},
  { prop: 'assetProduct.name',           name: 'Produit'                                        },
  { prop: 'receptionDate',               name: 'Date réception',          type : 'date'         },
 ]
 
 
  inventoriedAssets     : Asset[] = [];
  nonInventoriedAssets  : Asset[] = [];

  onClosing : boolean = false;


  constructor(
    protected assetInventoryService : AssetInventoryService,
    protected baseService           : BaseService,
    protected toastr                : ToastrService,
    protected leanUtilsService      : LeanUtilsService) {
    super(toastr, leanUtilsService);

    /*
    this.baseService.fieldsGet("asset").then(result => {
      this.assetColumns = result.listFields;
    });
    */
  }



  //------------------------------------------------------
  setEntity(assetInventory: AssetInventory) {
      this.assetInventory  = { ...assetInventory };

      this.assetInventory.assets.forEach(a => {
        if(a.inventoried) {
          this.inventoriedAssets.push(a);
        } else {
          this.nonInventoriedAssets.push(a);
        }
      })
  }
  getEntity(){
    return this.assetInventory;
  }
  //------------------------------------------------------


  //------------------------------------------------------
  saveRow() : Promise<AssetInventory>{
    return null;
  }
  //------------------------------------------------------

  
closeAssetInventory(){
  this.assetInventoryService.assetInventoryProcess('close',  this.assetInventory.assetInventoryCode).then(result => {
    this.assetInventory.closingDate = result.closingDate;
    this.leanUtilsService.toastr.success("Opération effectuée avec succès");
  })
}

selectAsset(row){

}
}
